import { Request } from '~src/httpClient/serverApi/requests/Request';
import { IResult } from '~src/httpClient/serverApi/types/IResponse';
import { IMultipleIdsParams } from '~src/spacesPlatform/utils/actionParams';

export class HideViewsRequest extends Request<IMultipleIdsParams, IResult> {
  constructor(ids: string[]) {
    super('hideViews', { ids: ids });
  }
}
